export default __webpack_public_path__ + "static/media/Button-Glow.c6dab816.png";